import { render, staticRenderFns } from "./VeiculoPartial.vue?vue&type=template&id=1a2e8c28&"
import script from "./VeiculoPartial.vue?vue&type=script&lang=js&"
export * from "./VeiculoPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports